const APPLICATION_TITLE = process.env.NEXT_PUBLIC_APPLICATION_TITLE as string;

export default APPLICATION_TITLE;
